import { type FC } from "react";
import { frameButton } from "./styles.css";
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
declare const $: any;

export type telButtonProps = {
  telNumber: string;
  position: string;
  clientShopId: number | string;
  gaLabel: string;
  pageType: string;
  capitalizePageType: string;
  workCode: string;
  isPreview: boolean;
};

export const TelButton: FC<telButtonProps> = ({
  telNumber,
  position,
  clientShopId,
  gaLabel,
  pageType,
  capitalizePageType,
  workCode,
  isPreview,
}) => {
  // 電話応募ボタンクリック時にクリックされた求人情報を送信
  const handleOnClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    $.fn.sendTelButtonAction({
      code: workCode,
      client_shop_id: clientShopId,
    });
  };

  return (
    // FIXME: isPreview時にjavascript:void(0)を使用しているためanchor-is-validに違反。button要素への変更を検討
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      /* eslint no-script-url: 0 */
      href={isPreview ? "javascript:void(0)" : `tel:${telNumber}`}
      className={`${frameButton} ga-click appier-click disable-on-preview`}
      data-ga-action={`${pageType}_entry_tel-${position}`}
      data-ga-label={gaLabel}
      data-appier-action={`trackTapJob${capitalizePageType}EntryTel`}
      data-client-shop-id={clientShopId}
      onClick={handleOnClick}
    >
      <i className="icon-phone" />
      電話で応募する
    </a>
  );
};
